module.exports = __webpack_public_path__ + "static/img/weihu.974d28c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weihu.jpg
// module id = aKVv
// module chunks = 1